import { AnalyticsBackend, AnalyticsEvent } from './AnalyticsService';
// @ts-expect-error TS doesn't like importing gtm.
import TagManager from 'react-gtm-module';
import gtm from '@utils/gtm.ts';
import { LOOKBOOK_PARAMETERS_TO_COPY } from '@pages/Root/pages/Lookbook/contants.ts';

export class GoogleAnalyticsService implements AnalyticsBackend {
  gtm?: TagManager;

  constructor() {
    this.gtm = gtm;
  }

  public init = (): void => {
    // GTM is initialized via the gtm module import; nothing to do here.
  };

  private translateEventParams = (event: any): any => {
    const returnEvent: { [key: string]: any } = {
      product_id: event.partnerId, //CMBU-1968 we want partnerid to be present in GTM's product_id property.
      page: event.page,
      type: event.type,
      origin_url: event.originUrl,
      destination_url: event.destinationUrl,
      action: event.action,
      page_number: event.pageNumber,
      ad_tag: event.adTag,
      ad_unit_id: event.adUnitId,
      content_id: event.contentId,
      title: event.title,
      content_owner: event.contentOwner,
      lbtype: event.lbtype,
      primary_interest: event.primaryInterest,
      language: event.language,
      source: event.source,
      eventCallback: event.eventCallback,
      eventTimeout: event.eventTimeout,
      schedule: event.schedule,
      duration: event.duration,
      reason: event.reason,
      loadTime: event.loadTime,
      errorType: event.errorType,
      errorMessage: event.errorMessage,
      name: event.name,
      target: event.target,
    };
    LOOKBOOK_PARAMETERS_TO_COPY.forEach((key: string) => {
      returnEvent[key] = event[key];
    });
    return Object.fromEntries(
      Object.entries(returnEvent).filter(
        ([, value]) => {return value !== null && value !== undefined}
      )
    );
  };

  public send = ({ name, params }: AnalyticsEvent): void => {
    const translatedParams = this.translateEventParams(params);
    console.log(
      `[GoogleAnalyticsService] Tracking Event: '${name}'`,
      translatedParams
    );
    this.gtm?.emit({
      event: name,
      ...translatedParams,
    });
  };
}
